<script setup lang="ts">
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';

import { showDynamicContact } from '../utils/contact';

const handleClick = () => {
  showDynamicContact(1078253, '企业需求咨询', '扫码加行业专家·快速响应');
};
</script>

<template>
  <ArrowBtn text="获取定制方案" variant="black-middle" @click="handleClick" />
</template>
